import { Shark, Utils, View } from "shark-mvc";
import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import { Modal, Tab} from "bootstrap";
import moment from "moment";
import listPlugin from "@fullcalendar/list";
import timeGridPlugin from "@fullcalendar/timegrid";

import Task from "../../models/Task";

import templateContent from "./stats.html";
import "./style.css";

import activeWorkSessionDisplayComponent from "../../components/activeWorkSessionDisplay/activeWorkSessionDisplayComponent";
import clientManager from "../../managers/clientManager";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import messageModalComponent from "../../components/messageModal/messageModalComponent";
import projectStatsComponent from "../../components/projectStats/projectStatsComponent";
import systemComponent from "../../components/systemComponent";
import taskManager from "../../managers/taskManager";
import userManager from "../../managers/userManager";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import workSessionDetailsModalComponent from "../../components/workSessionDetailsModal/workSessionDetailsModalComponent";
import workSessionManager from "../../managers/workSessionManager";

class StatsView extends View {
	constructor () {
		super("statsView");

		this.setTemplate(templateContent);
		this.$mainRoute = "stats";
	}

	afterLoad () {
		this.modal = new Modal(document.querySelector("#reportModal"));
		const currentTab = localStorage.getItem("currentTab");
		
		document.querySelectorAll(`[data-bs-toggle="tab"]`).forEach(item => {
			item.addEventListener("show.bs.tab", (event) => {
				// console.log(event.target.id);
				const newStatsViewSettings = {
					currentTab: event.target.id,
				};
				Shark.set({
					statsViewSettings: newStatsViewSettings,
				});
				localStorage.currentTab = event.target.id;

				document.querySelectorAll(`[data-trigger-tab]`).forEach(item => item.classList.add("d-none"));
				document.querySelectorAll(`[data-trigger-tab="${event.target.id}"]`).forEach(item => item.classList.remove("d-none"));
			});
		});

		if (currentTab) { 
			Tab.getOrCreateInstance(document.querySelector(`#${currentTab}`)).show();
		}

		// this.initCalendar();
	}
	
	beforeLoad () {
		const currentTab = localStorage.getItem("currentTab");
		let statsViewSettings = {};

		if (!currentTab) {
			statsViewSettings = {
				currentTab: "",
			};
		}

		Shark.set({
			statsViewSettings,
		});

		// oggetto stats view settings recuperato
		this.updateMenuTitle();
		this.refreshReport();
	}

	// Dave: Questo è replicato nella Home, possiamo unificare?
	checkRunningWorksessionProjectAndTask () {
		const { fullClientList, fullProjectList, fullTaskList, runningWorkSession } = Shark.get();

		if (runningWorkSession) {
			if (fullClientList) {
				fullClientList.forEach(item => item.__isRunningWorkSessionCustomer = item.guid === runningWorkSession.clientGuid);
			}
			if (fullProjectList) {
				fullProjectList.forEach(item => item.__isRunningWorkSessionProject = item.guid === runningWorkSession.projectGuid);
			}
			if (fullTaskList) {
				fullTaskList.forEach(item => item.__isRunningWorkSessionTask = item.guid === runningWorkSession.taskGuid);
			}
		}
		else {
			if (fullClientList) {
				fullClientList.forEach(item => item.__isRunningWorkSessionCustomer = false);
			}
			if (fullProjectList) {
				fullProjectList.forEach(item => item.__isRunningWorkSessionProject = false);
			}
			if (fullTaskList) {
				fullTaskList.forEach(item => item.__isRunningWorkSessionTask = false);
			}
		}
	}
	
	copyCSVToClipboard (guid) {
		const csvContent = this.generateCSVReport(guid);
		navigator.clipboard.writeText(csvContent);
	}

	copyCSVToClipboardBtn_clickHandler (event, data) {
		this.copyCSVToClipboard(data.guid);
	}

	// editWorkSessionBtn_clickHandler (event, data) {
	// 	const { fullWorkSessionList } = Shark.get();
	// 	const currWorkSession = Utils.safp(fullWorkSessionList, "guid", data.guid);
	// 	console.log(currWorkSession);
	// 	const filters = { projectGuid: currWorkSession.projectGuid };

	// 	taskManager.getList2(filters, true)
	// 	.then(getResponse => {
	// 		Shark.set({
	// 			manualWorkSession: currWorkSession,
	// 		});
	// 		workSessionDetailsModalComponent.open(getResponse.data);
	// 	});
	// }

	generateCSVContent (printReport) {
		const { projectReport } = Shark.get();
		const itemToExport = [];
		const titleRow = {};

		if (printReport.visibleColumns.tags) {
			titleRow.tags = "tags";
		}
		if (printReport.visibleColumns.projectName) {
			titleRow.projects = "project";
		}
		if (printReport.visibleColumns.taskName) {
			titleRow.name = "name";
		}
		if (printReport.visibleColumns.duration) {
			titleRow.duration = "duration";
		}
		if (printReport.visibleColumns.durationSec) {
			titleRow.durationSec = "durationSec";
		}
		if (printReport.visibleColumns.moneyAmount) {
			titleRow.cost = "cost";
		}

		printReport.rows.forEach(item => {
			const singleRow = {};

			if (printReport.visibleColumns.tags) {
				singleRow.tags = item.tags;
			}
			if (printReport.visibleColumns.projectName) {
				singleRow.projects = item.projects;
			}
			if (printReport.visibleColumns.taskName) {
				singleRow.name = item.name;
			}
			if (printReport.visibleColumns.duration) {
				singleRow.duration = item.duration;
			}
			if (printReport.visibleColumns.durationSec) {
				singleRow.durationSec = item.durationSec;
			}
			if (printReport.visibleColumns.moneyAmount) {
				singleRow.cost = item.cost;
			}

			itemToExport.push(singleRow);
			// 	cost: item.cost,
			// 	projects: item.projects,
			// 	name: item.name,
			// 	duration: item.duration,
			// 	// durationHours: Shark.$store.numberFormatter.format(task.__duration / 3600000)
			// });
		});

		itemToExport.unshift(titleRow);
		// console.log({itemToExport, projectReport});
		return itemToExport;
	}

	generateCSVReport (guid) {
		const printReport = this.generatePrintReport(guid);
		const itemToExport = this.generateCSVContent(printReport);
		const fields = {...itemToExport[0]};

		exportCSVComponent.set({
			savedFileBaseName: "Report - " + printReport.clientName,
			exportMap: {
				name: "Task",
				id: "taskMap",
				fields,
			},
		});
		exportCSVComponent.set({
			listToExport: itemToExport,
		});

		const csvContent = exportCSVComponent.generateCSV(false);

		return csvContent;
	}

	generatePrintReport (clientGuid) {
		const { projectReport, statsFilters } = Shark.get();
		let reportClient;
	
		const printReport = {
			clientName: "",
			rows: [],
			timeRagenEndLabel: moment(statsFilters.periodEnd).format("DD/MM/YYYY"),
			timeRagenStartLabel: moment(statsFilters.periodStart).format("DD/MM/YYYY"),
			totalCost: 0,
			totalDuration: 0,
			totalDurationLabel: "",
		};

		projectReport.forEach(organization => {
			// Dave: Alice, occhio che questo qui sotto deve rimanere clientList perché è costruita altrove e se non modifichiamo quella in "customerList" si rompe tutto.
			organization.clientList.forEach(client => {
				if (client.guid === clientGuid) {
					reportClient = client;
					printReport.clientName = client.name;
					printReport.totalCost = client.totalInvoiceValueLabel;
					printReport.totalDurationHour = Shark.$store.numberFormatter.format(client.totalDuration / 3600000);
					printReport.totalDurationLabel = client.totalDurationLabel;
					client.projectList.forEach(project => {
						project.taskList.forEach(task => {
							printReport.rows.push({
								cost: task.__invoiceValueLabel,
								duration: task.__durationLabel,
								durationSec: task.__duration / 1000,
								name: task.name,
								projects: project.name,
								tags: project.__tagsString,
							});
						});
					});
				}
			});
		});

		if (reportClient) {
			printReport.visibleColumns = reportClient.reportSettings.columns.visible;
		}

		// console.log({clientGuid, printReport, projectReport});
		console.table(printReport.rows);

		return printReport;
	}

	init () {
		this.addComponents([activeWorkSessionDisplayComponent, exportCSVComponent, mainNavComponent, messageModalComponent, projectStatsComponent, waitBoxComponent, workSessionDetailsModalComponent]);

		const statsFiltersRawData = localStorage.statsFilters;
		let statsFiltersData;

		// console.log("paradosso");
		// console.log(statsFiltersRawData);
		if (statsFiltersRawData) {
			statsFiltersData = JSON.parse(statsFiltersRawData);
			// console.log(statsFiltersData);
		}

		const statsFilters = Shark.getInstance("__smart__", {
			clientGuid: "",
			selectedCustomerGuidList: statsFiltersData?.selectedCustomerGuidList || [],
			selectedOrganizationGuidList: statsFiltersData?.selectedOrganizationGuidList || [],
			selectedUserGuidList: statsFiltersData?.selectedUserGuidList || [],
			periodStart: moment().startOf("month").format("YYYY-MM-DD"),
			periodEnd: moment().endOf("month").format("YYYY-MM-DD"),
			searchKey: "",
			singleMonth: moment().format("YYYY-MM"),
			userGuid: "",
			userGuidList: statsFiltersData?.userGuidList || [],
		});

		statsFilters.onSingleMonthChanged = function () {
			console.time("onSingleMonthChanged");
			this.set({
				periodStart: moment(this.singleMonth).startOf("month").format("YYYY-MM-DD"),
				periodEnd: moment(this.singleMonth).endOf("month").format("YYYY-MM-DD"),
			});
			console.timeEnd("onSingleMonthChanged");
		};

		statsFilters.onSelectedOrganizationGuidListChanged =  function () {
			statsView.updateCustomerListForFilter();
		};

		statsFilters.onSelectedCustomerGuidListChanged =  function () {
			statsView.updateSelectedCustomer();
		};

		// statsFilters.onSelectedUserGuidListChanged =  function () {
		// 	statsView.updateSelectedUser();
		// };

		statsFilters.onDataChanged = function () {
			localStorage.statsFilters = JSON.stringify(this);
		};

		Shark.set({
			customerListForFilter: [],
			printReport: null,
			projectReport: [],
			statsFilters,
			statsSelectedDuration: 0,
			statsSelectedDurationLabel: "",
			selectedExternalCostLabel: "",
			selectedInternalCostLabel: "",
			selectedInvoiceValueLabel: "",
			__allCustomerSelectedCSSClasses: "active",
		});

		this.updateSelectedTotals();
	}

	initCalendar () {
		const calendarContainer = document.querySelector("#calendarContainer");

		if (calendarContainer) {
			const { fullWorkSessionList } = Shark.get();
			const eventList = [];

			if (fullWorkSessionList) {
				const daysMap = new Map();

				fullWorkSessionList.forEach(workSession => {
					if (!daysMap.has(workSession.__startDate)) {
						daysMap.set(workSession.__startDate, { date: workSession.__startDate, sessionList: [] });
					}
					
					daysMap.get(workSession.__startDate).sessionList.push(workSession);
				});

				daysMap.forEach(day => {
					day.projectMap = new Map();
					day.sessionList.forEach(workSession => {
						if (!day.projectMap.has(workSession.__projectName)) {
							day.projectMap.set(workSession.__projectName, { label: workSession.__projectName, sessionList: [] });
						}

						day.projectMap.get(workSession.__projectName).sessionList.push(workSession);
					});

					day.userMap = new Map();
					day.sessionList.forEach(workSession => {
						if (!day.userMap.has(workSession.__ownerName)) {
							day.userMap.set(workSession.__ownerName, { label: workSession.__ownerName, sessionList: [] });
						}

						day.userMap.get(workSession.__ownerName).sessionList.push(workSession);
					});

					day.durationTotal = day.sessionList.reduce((total, item) => total += item.__duration, 0);

					if (true) {
						day.projectMap.forEach(project => eventList.push({
							id: "a" + project.label,
							title: project.label,
							start: day.date,
						}));
					}
					else {
						day.userMap.forEach(user => eventList.push({
							id: "a" + user.label,
							title: user.label,
							start: day.date,
						}));
					}							

					eventList.push({
						id: "a" + day.date,
						title: "Durata: " + Math.round(day.durationTotal / 3_600_000),
						start: day.date,
					});
				});

				// console.log({daysMap, eventList});
			}

			this.calendar = new Calendar(calendarContainer, {
				events: eventList,
				headerToolbar: {
					left: "prev,next today",
					center: "title",
					right: "dayGridMonth,timeGridWeek,listWeek",
				},
				initialView: "dayGridMonth",
				plugins: [ dayGridPlugin, timeGridPlugin, listPlugin ],
			});

			this.calendar.render();
		}
	}

	printBtn_clickHandler () {
		window.print();
	}

	refreshBtn_clickHandler () {
		this.refreshReport();
	}

	async refreshReport () {
		waitBoxComponent.open();
		let { currUser, organizationList, statsFilters, userList } = Shark.get();
		
		if (!organizationList) {
			await systemComponent.prepareSystemData();
			organizationList = Shark.get("organizationList");
		}

		this.updateCustomerListForFilter();

		if (!userList || userList.length === 0) {
			await userManager.getListForMyOrganization();
		}

		// Dave.ToDo: dovrei separare il recupero dei dati dal process, così da poter aggiornre i conteggi senza dove richiedere tutti i dati.
		// console.log({statsFilters});
		await workSessionManager.getReport(statsFilters);

		const { fullWorkSessionList } = Shark.get();
		const workSessionsByDate = {};

		let fullWorkSessionListReversed = fullWorkSessionList?.reverse();

		fullWorkSessionListReversed?.filter(item => item.userGuid === currUser.guid).forEach(item => {
			const date = item.__startDate;
			if(workSessionsByDate[date]) {
				workSessionsByDate[date].push(item);
			}
			else {
				workSessionsByDate[date] = [item];
			}
		});

		const workSessionsByDateList = Object.entries(workSessionsByDate).map(item => {
			return {
				label: item[0],
				workSessionList: item[1],
			};
		});

		Shark.set({
			workSessionsByDateList,
		});

		this.checkRunningWorksessionProjectAndTask();
		waitBoxComponent.close();

		this.initCalendar();
	}

	async resetFilters () {
		let { clientList } = Shark.get();
		const {organizationList, statsFilters, userList } = Shark.get();

		if (!clientList || clientList.length === 0) {
			await clientManager.getList();
			clientList = Shark.get("clientList");
		}

		statsFilters.set({
			clientGuid: "",
			selectedCustomerGuidList: clientList.map(item => item.guid),
			selectedOrganizationGuidList: organizationList.map(item => item.guid),
			selectedUserGuidList: userList.map(item => item.guid),
			periodStart: moment().startOf("month").format("YYYY-MM-DD"),
			periodEnd: moment().endOf("month").format("YYYY-MM-DD"),
			searchKey: "",
			singleMonth: moment().format("YYYY-MM"),
			userGuid: "",
			userGuidList: userList.map(item => item.guid),
		});

		this.refreshReport();
	}

	resetFiltersBtn_clickHandler () {
		this.resetFilters();
	}

	resetWSSelection () {
		const { fullTaskList, fullWorkSessionList } = Shark.get();

		fullTaskList.forEach(item => {
			item.__selected = false;
		});

		fullWorkSessionList.forEach(item => {
			item.__selected = false;
		});

		// Alice was here
		Shark.set({
			__statsSelection: false,
		});

		this.updateSelectedTotals();
	}

	resetWSSelectionBtn_clickHandler () {
		this.resetWSSelection();
	}

	saveCSVBtn_clickHandler (event, data) {
		const csvContent = this.generateCSVReport(data.guid);
		exportCSVComponent.saveCSVFileToUser(csvContent);
	}

	async updateCustomerListForFilter () {
		let { clientList, statsFilters } = Shark.get();
		const { organizationList, organizationMembershipList } = Shark.get();
		if (!clientList || clientList.length === 0) {
			await clientManager.getList();
			clientList = Shark.get("clientList");
		}
		
		let customerListByOrganizationForFilter = organizationList.map(item => {
			return { guid: item.guid, name: item.name, color: organizationMembershipList ? organizationMembershipList.find(membership => membership.organizationGuid == item.guid)?.activityColor :  "color-0", customerList: [], __allCustomerSelected: false};
		});
		
		if(statsFilters.selectedOrganizationGuidList) {
			customerListByOrganizationForFilter = customerListByOrganizationForFilter.filter(item => statsFilters.selectedOrganizationGuidList.includes(item.guid));
		}
		
		let __customerListByOrganizationForFilterCount = 0;
		clientList.forEach(item => {
			const organization = customerListByOrganizationForFilter.find(organization => organization.guid === item.organizationGuid);
			if (organization) {
				organization.customerList.push(item);
				__customerListByOrganizationForFilterCount++;
			}
		});

		if(statsFilters.selectedCustomerGuidList){
			statsFilters.selectedCustomerGuidList = clientList.filter(item => statsFilters.selectedCustomerGuidList.includes(item.guid) && statsFilters.selectedOrganizationGuidList.includes(item.organizationGuid)).map(item => item.guid);
		}

		Shark.set({
			__allOrganizationSelected: statsFilters.selectedOrganizationGuidList.length >= organizationList.length,
			customerListByOrganizationForFilter,
			__customerListByOrganizationForFilterCount,
			statsFilters,
		});
		this.updateSelectedCustomer();
	}

	updateSelectedCustomer () {
		//ALICE: mi ripeto non mi piace
		let { clientList, customerListByOrganizationForFilter, statsFilters} = Shark.get();

		customerListByOrganizationForFilter.forEach(organization => {
			let oragnizationCustomers = clientList.filter(item => item.organizationGuid == organization.guid);
			let selectedOragnizationCustomers = oragnizationCustomers.filter(item => statsFilters.selectedCustomerGuidList.includes(item.guid));

			organization.__allCustomerSelected = selectedOragnizationCustomers.length >= oragnizationCustomers.length;
		});

		let __customerListByOrganizationForFilterCount = 0;
		clientList.forEach(item => {
			const organization = customerListByOrganizationForFilter.find(organization => organization.guid === item.organizationGuid);
			if (organization) {
				__customerListByOrganizationForFilterCount++;
			}
		});

		let allCustomersVisibile = [];
		customerListByOrganizationForFilter.forEach(organization => {
			organization.customerList.forEach(customer => {
				allCustomersVisibile.push(customer.guid);
			});
		});		

		let __allCustomerSelected = statsFilters.selectedCustomerGuidList.length >= allCustomersVisibile.length;

		Shark.set({
			__allCustomerSelected,
			__customerListByOrganizationForFilterCount,
			customerListByOrganizationForFilter,
		});			

		// Shark.render(); // Mi aspetteri che lo tracciasse in automatico
	}

	selectAllOrganizationBtn_clickHandler () {
		let { statsFilters } = Shark.get();
		const { organizationList } = Shark.get();

		let organizationToAdd = organizationList.map(item => item.guid);
		const __allOrganizationSelected = statsFilters.selectedOrganizationGuidList.length < organizationToAdd.length;
		if(__allOrganizationSelected) {
			statsFilters.selectedOrganizationGuidList = organizationToAdd;
		}
		else {
			statsFilters.selectedOrganizationGuidList = [];
		}
		Shark.set({
			statsFilters,
			__allOrganizationSelected,
		});			
		// console.log(statsFilters.selectedOrganizationGuidList);
		statsView.updateCustomerListForFilter();
		// Shark.render(); // Mi aspetteri che lo tracciasse in automatico
	}

	selectAllUsersBtn_clickHandler () {
		let { statsFilters, userList} = Shark.get();

		let userToAdd = userList.map(item => item.guid);
		// console.log(userToAdd);
		const __allUserSelected = statsFilters.selectedUserGuidList.length < userToAdd.length;
		if(__allUserSelected) {
			statsFilters.selectedUserGuidList = userToAdd;
		}
		else {
			statsFilters.selectedUserGuidList = [];
		}
		Shark.set({
			statsFilters,
			__allUserSelected,
		});			
		// Shark.render(); // Mi aspetteri che lo tracciasse in automatico
	}

	selectAllCustomerBtn_clickHandler () {
		this.updateSelectedCustomer();
		let { __allCustomerSelected, customerListByOrganizationForFilter, statsFilters } = Shark.get();
		const { clientList } = Shark.get();

		// console.log(__allCustomerSelected);
		// console.log(clientList);
		// console.log(customerListByOrganizationForFilter);
		
		let customersToAdd = [];
		customerListByOrganizationForFilter.forEach(organization => {
			organization.customerList.forEach(customer => {
				customersToAdd.push(customer.guid);
			});
		});

		// console.log(customersToAdd);

		if(__allCustomerSelected) {
			statsFilters.selectedCustomerGuidList = [];
		}
		else {
			statsFilters.selectedCustomerGuidList = customersToAdd;
		}
		
		Shark.set({
			statsFilters,
		});			
		this.updateSelectedCustomer();
		// Shark.render(); // Mi aspetteri che lo tracciasse in automatico
	}

	selectAllCustomerForOrganizationBtn_clickHandler (event, data) {
		if(data.guid) {
			let { statsFilters, customerListByOrganizationForFilter } = Shark.get();
			const { clientList } = Shark.get();

			let oragnizationCustomers = clientList.filter(item => item.organizationGuid == data.guid);
			let selectedOragnizationCustomers = oragnizationCustomers.filter(item => statsFilters.selectedCustomerGuidList.includes(item.guid));

			// console.log(oragnizationCustomers);
			// console.log(selectedOragnizationCustomers);

			let __allCustomerSelected = selectedOragnizationCustomers.length < oragnizationCustomers.length;
			if(__allCustomerSelected) {
				// console.log("non selezionati tutti");
				oragnizationCustomers.forEach(client => {
					if(!statsFilters.selectedCustomerGuidList.includes(client.guid)) {
						statsFilters.selectedCustomerGuidList.push(client.guid);
					} 
				});	
			}
			else {
				// console.log("selezionati tutti");
				oragnizationCustomers.forEach(client => {
					if(statsFilters.selectedCustomerGuidList.includes(client.guid)) {
						statsFilters.selectedCustomerGuidList.splice(statsFilters.selectedCustomerGuidList.indexOf(client.guid), 1);
					}
				});	
			}

			customerListByOrganizationForFilter.find(item => item.guid == data.guid).__allCustomerSelected = __allCustomerSelected;
			// console.log(statsFilters.selectedCustomerGuidList);
			Shark.set({
				__allCustomerSelected: statsFilters.selectedCustomerGuidList.length >= clientList.length,
				customerListByOrganizationForFilter,
				statsFilters,
			});		
			this.updateSelectedCustomer();
	
			//Shark.render(); // Mi aspetteri che lo tracciasse in automatico
		}
	}

	selectInverseCustomerBtn_clickHandler () {
		let { customerListByOrganizationForFilter, statsFilters } = Shark.get();

		let customersToAdd = [];
		customerListByOrganizationForFilter.forEach(organization => {
			organization.customerList.forEach(customer => {
				if(!statsFilters.selectedCustomerGuidList.includes(customer.guid))
				{
					customersToAdd.push(customer.guid);
				}
			});
		});

		statsFilters.selectedCustomerGuidList = customersToAdd;
		
		Shark.set({
			statsFilters,
		});			
		this.updateSelectedCustomer();
		// Shark.render(); 
	}

	selectInverseOrganizationBtn_clickHandler () {
		let { statsFilters } = Shark.get();
		const { organizationList } = Shark.get();
		
		let organizationToAdd = [];
		organizationList.forEach(organization => {
			if(!statsFilters.selectedOrganizationGuidList.includes(organization.guid))
			{
				organizationToAdd.push(organization.guid);
			}
		});

		statsFilters.selectedOrganizationGuidList = organizationToAdd;
		
		Shark.set({
			statsFilters,
		});			
		// this.updateSelectedCustomer();
		// Shark.render();
	}

	selectInverseUsersBtn_clickHandler () {
		let { statsFilters, userList} = Shark.get();

		let userToAdd = [];
		userList.forEach(user => {
			if(!statsFilters.selectedUserGuidList.includes(user.guid))
			{
				userToAdd.push(user.guid);
			}
		});

		statsFilters.selectedUserGuidList = userToAdd;

		Shark.set({
			statsFilters,
		});
	}

	showReportBtn_clickHandler (event, data) {
		const printReport = this.generatePrintReport(data.guid);

		Shark.set({ printReport });
		// $("#reportModal").modal("show");
		if (this.modal) {
			this.modal.show();
		}
	}

	singleProject_clickHandler (event, data) {
		if (event.target.classList.contains("preventSelection") || event.target.classList.contains("singleTask")) {
			event.preventDefault();
			return;
		}

		const projectGuid = data.guid;
		const { fullProjectList } = Shark.get();
		const currProject = Utils.safp(fullProjectList, "guid", projectGuid);

		currProject.set({
			__selected: !currProject.__selected,
		});

		// Alice was here
		Shark.set({
			__statsSelection: true,
		});

		currProject.taskList.forEach(task => {
			task.__selected = currProject.__selected;
			task.workSessionList.forEach(item => item.__selected = task.__selected);
		});

		this.updateSelectedTotals();
	}

	singleSession_clickHandler (event, data) {
		if (event.target.classList.contains("preventSelection")) {
			event.preventDefault();
			return;
		}
		// if (event.target.nodeName === "BUTTON" || event.target.closest(".userDisplay")) {
		// 	return;
		// }

		const workSessionGuid = data.guid;
		const { fullTaskList, fullWorkSessionList } = Shark.get();
		const currWorkSession = Utils.safp(fullWorkSessionList, "guid", workSessionGuid);

		currWorkSession.set({
			__selected: !currWorkSession.__selected,
		});

		const currTask = Utils.safp(fullTaskList, "guid", currWorkSession.taskGuid);
		const taskSelected = currTask.workSessionList.find(item => !item.__selected) === undefined;

		currTask.set({
			__selected: taskSelected,
		});

		Shark.set({
			__statsSelection: true,
		});

		this.updateSelectedTotals();
	}

	singleTask_clickHandler (event, data) {
		if (event.target.classList.contains("preventSelection")) {
			event.preventDefault();
			return;
		}

		const taskGuid = data.guid;
		const { fullProjectList, fullTaskList } = Shark.get();
		const currTask = Utils.safp(fullTaskList, "guid", taskGuid);

		currTask.set({
			__selected: !currTask.__selected,
		});

		const currProject = Utils.safp(fullProjectList, "guid", currTask.projectGuid);
		const projectSelected = currProject.taskList.find(item => !item.__selected) === undefined;

		currProject.set({
			__selected: projectSelected,
		});


		// Alice was here
		Shark.set({
			__statsSelection: true,
		});

		currTask.workSessionList.forEach(item => item.__selected = currTask.__selected);

		this.updateSelectedTotals();
	}

	syncProjectWrikeTimelogBtn_clickHandler () {
		alert("Lo so, ti piacerebbe, ma non sono ancora capace di sincronizzare un intero Progetto, mi spiace...");
	}

	async syncWrikeTimelog (task)  {
		waitBoxComponent.open();

		let syncType = "workSessions";
		let fixedHourDurationForValueMS = -1;

		if (task.fixedValue > 0) {
			const taskClient = Utils.safp(Shark.$store?.customerList, "guid", task.__clientGuid);

			if (taskClient) {
				fixedHourDurationForValueMS = Math.round((task.fixedValue / taskClient.fixedHourlyValue) * 3_600_000);
				syncType = "fixedDuration";
			}
			else {
				alert("Aiuto, errore!!! Chiama Dave!!!");
			}
		}
		else if (task.fixedDuration > 0) {
			fixedHourDurationForValueMS = task.fixedDuration * 3_600_000;
			syncType = "fixedDuration";
		}

		let alredySyncDurationMS = 0;

		const taskWSGuidList = task.workSessionList.map(item => item.guid);
		const taskSyncronizedWSGuidList = task.extraData.wrikeSyncList.reduce((list, item) => {
			// console.log({list, item})
			if (typeof item.syncDuration !== "undefined") {
				alredySyncDurationMS += item.syncDuration;
			}

			list.push(...item.wsGuids);
			return list;
		}, []);
		
		const wsNotSyncronizedGuidList = taskWSGuidList.filter(item => !taskSyncronizedWSGuidList.includes(item));
		const wsNotSyncronizedList = task.workSessionList.filter(item => wsNotSyncronizedGuidList.includes(item.guid));
		let durationToAddMS = fixedHourDurationForValueMS > -1 ? fixedHourDurationForValueMS : wsNotSyncronizedList.reduce((total, item) => total + item.durationMS, 0);
		const couldSync = fixedHourDurationForValueMS === -1 || alredySyncDurationMS < durationToAddMS;

		if (alredySyncDurationMS > 0) {
			durationToAddMS -= alredySyncDurationMS;
		}
		
		// console.log({alredySyncDurationMS, couldSync, durationToAddMS, fixedHourDurationForValueMS, syncType, task, taskWSGuidList, taskSyncronizedWSGuidList, wsNotSyncronizedGuidList, wsNotSyncronizedList});

		if (couldSync && durationToAddMS > 0) {
			const taskName = task.name;
			const wrikeTaskCode = taskName.slice(2, taskName.indexOf(" -"));

			const wrikeTaskResult = await fetch(`https://www.wrike.com/api/v4/tasks?permalink=https://www.wrike.com/open.htm?id=${wrikeTaskCode}`, {
				headers: {
					"Authorization": "bearer eyJ0dCI6InAiLCJhbGciOiJIUzI1NiIsInR2IjoiMSJ9.eyJkIjoie1wiYVwiOjU1MTAzOTQsXCJpXCI6ODQ0MDM2MSxcImNcIjo0NjM2MTk0LFwidVwiOjEzMjQ1MDk1LFwiclwiOlwiVVNcIixcInNcIjpbXCJXXCIsXCJGXCIsXCJJXCIsXCJVXCIsXCJLXCIsXCJDXCIsXCJEXCIsXCJNXCIsXCJBXCIsXCJMXCIsXCJQXCJdLFwielwiOltdLFwidFwiOjB9IiwiaWF0IjoxNjY4MTYyNjM2fQ.Lves_vNxps7Kmk_bXpTqTRrZmsaOrxcPmhWJoqAQfjg",
				}
			}).then(response => response.json());

			// console.log({task, wrikeTaskCode, wrikeTaskResult});

			const wrikeTask = wrikeTaskResult?.data?.[0];

			if (wrikeTask) {
				const wrikeTaskId = wrikeTask.id;
				const timelogDescription = task.status === Task.STATUS_CLOSED ? "Completamento attività." : "Progresso attività.";
				// Devo arrotondare al minuto superiore.
				const durationM = durationToAddMS / 60000;
				const durationH = Math.ceil(durationM) / 60;
				
				const { statsFilters } = Shark.get();
				let trackedDate = moment().format("YYYY-MM-DD");
				
				// Quando sincronizzo, se sto guardando un mese precedente, devo mettere il "trackedDate" = all'ultimo giorno "del mese", così che Wrike veda i report correttamente (allineati con TCorder).
				if (new Date() > new Date(statsFilters.periodEnd)) {
					// console.log("STO SINCRONIZZANDO IL MESE VECCHIO!!!");
					trackedDate = moment(statsFilters.periodEnd).format("YYYY-MM-DD");
				}

				const timeLogsToAddCount = Math.ceil(durationH / 24);

				let remainingTime = durationH;
				const timeLogsToAdd = [];

				for (let i = 0; i < timeLogsToAddCount; i++) {
					timeLogsToAdd.push(Math.min(remainingTime, 24));
					remainingTime -= 24;
				}
		
				for (let timeLogDurationH of timeLogsToAdd) {
					const postURL = `https://www.wrike.com/api/v4/tasks/${wrikeTaskId}/timelogs?comment=${timelogDescription}&hours=${timeLogDurationH}&trackedDate=${trackedDate}&categoryId=IEAFIFH2OQAAFNQX`;
					// console.log({durationM, wrikeTaskId, postURL, statsFilters});

					const wrikeTimelogResult = await fetch(postURL, {
						headers: {
							"Authorization": "bearer eyJ0dCI6InAiLCJhbGciOiJIUzI1NiIsInR2IjoiMSJ9.eyJkIjoie1wiYVwiOjU1MTAzOTQsXCJpXCI6ODQ0MDM2MSxcImNcIjo0NjM2MTk0LFwidVwiOjEzMjQ1MDk1LFwiclwiOlwiVVNcIixcInNcIjpbXCJXXCIsXCJGXCIsXCJJXCIsXCJVXCIsXCJLXCIsXCJDXCIsXCJEXCIsXCJNXCIsXCJBXCIsXCJMXCIsXCJQXCJdLFwielwiOltdLFwidFwiOjB9IiwiaWF0IjoxNjY4MTYyNjM2fQ.Lves_vNxps7Kmk_bXpTqTRrZmsaOrxcPmhWJoqAQfjg",
						},
						method: "POST",
					}).then(response => response.json());

					wrikeTimelogResult.syncType = syncType;
					if (syncType === "fixedDuration") {
						wrikeTimelogResult.syncDuration = Math.round(timeLogDurationH * 3_600_000);//fixedHourDurationForValueMS;
					}
					wrikeTimelogResult.wsGuids = wsNotSyncronizedList.map(item => item.guid);
					task.extraData.wrikeSyncList.push(wrikeTimelogResult);
					// console.log({wrikeTimelogResult});
				}

				await taskManager.save(task);
			}
		}

		waitBoxComponent.close();
	}

	syncWrikeTimelogBtn_clickHandler (event, data)  {
		const { fullTaskList } = Shark.get();
		const currTask = Utils.safp(fullTaskList, "guid", data.guid);

		if (currTask) {
			this.syncWrikeTimelog(currTask);
		}
	}

	updateMenuTitle () {
		Shark.set({
			__menuTitle: Shark.$store.labels.stats,
		});
	}

	updateSelectedTotals () {
		const { fullWorkSessionList } = Shark.get();
		let selectedDuration = 0;
		let selectedExternalCost = 0;
		let selectedInternalCost = 0;
		let selectedInvoiceValue = 0;

		if (fullWorkSessionList) {
			fullWorkSessionList.forEach(item => {
				if (item.__selected) {
					selectedDuration += item.duration;
					selectedExternalCost += item.__userExternalCost;
					selectedInternalCost += item.__userInternalCost;
					selectedInvoiceValue += item.__invoiceValue;
				}
			});
		}

		Shark.set({
			statsSelectedDuration: selectedDuration,
			statsSelectedDurationLabel: moment.duration(selectedDuration).format("HH:mm:ss", { trim: false }),
			selectedExternalCostLabel: Shark.$store.moneyFormatter.format(selectedExternalCost),
			selectedInternalCostLabel: Shark.$store.moneyFormatter.format(selectedInternalCost),
			selectedInvoiceValueLabel: Shark.$store.moneyFormatter.format(selectedInvoiceValue),
		});
	}

	workSessionManager_openWSCheckedHandler () {
		statsView.checkRunningWorksessionProjectAndTask();
	}

	workSessionManager_singleWorkSessionUpdatedHandler () {
		statsView.refreshReport();
	}
}

const statsView = new StatsView();

Shark.registerView(statsView);

export default statsView;
